import { useAppSelector } from '../../app/hooks';
import SessionError from './SessionError';
import { selectExceptionMessage } from '../../app/slices/exception.slice';

const SessionErrorPage = () => {
	const message = useAppSelector(selectExceptionMessage) as string;

	return <SessionError errorMessage={message} />;
};

export default SessionErrorPage;
